module.exports = {"TXTCLI_Collect_inX_N0":{"id":"TXTCLI_Collect_inX_N0","defaultMessage":"Inkassera om: {0}","flags":["TRACK"],"track":"Collect in: {0}"}}